import { localDay, startOfLocalDay } from "@omnabase/shared";

/** Profile › Away › "Back on" (the settings copy two round, 2026-11-04, review finding 9): the day a person picks is kept and shown in their
 *  profile's time zone, whatever zone the browser runs in. The stored moment is the start of that day there; the field shows that day again. */

/** the stored moment for a picked day ("2027-03-10"): midnight of that day in the zone, as an ISO string; empty means no day */
export const awayMomentOf = (day: string, zone: string): string | null => (day ? startOfLocalDay(day, zone).toISOString() : null);

/** the day the field shows for a stored moment, read in the zone; empty when there is none */
export const awayDayOf = (moment: string | null | undefined, zone: string): string => (moment ? localDay(new Date(moment), zone) : "");

/** a day ("2027-03-10") as the browser's noon of that day, so a date formatter in any browser zone names that same day */
export const dayAtNoon = (day: string): string => `${day}T12:00:00`;
